import { baseUrl } from '@/api/types';

export function invoiceIndexUrl() {
  return `${baseUrl}/invoices`;
}

export function invoiceListUrl() {
  return `${invoiceIndexUrl()}/list`;
}

export function invoiceCreateUrl() {
  return `${invoiceIndexUrl()}/create`;
}

export function invoiceEditUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}/edit/`;
}

export function invoiceDetailsUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}/details`;
}

export function invoiceChangesHistoryIndexUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}/changes`;
}

export function invoiceChangesDetailsUrl(activityId) {
  return `${invoiceIndexUrl()}/${activityId}/changes/details`;
}

export function invoiceShareUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}/share`;
}

export function invoiceStoreUrl() {
  return invoiceIndexUrl();
}

export function invoiceUpdateUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}`;
}

export function invoiceDeleteUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}`;
}

export function invoiceFileFormUrl() {
  return `${invoiceIndexUrl()}/files`;
}

export function invoiceRequisitesIndexUrl() {
  return `${baseUrl}/invoice-requisites`;
}

export function invoiceRequisitesUpdateUrl(invoiceId) {
  return `${invoiceRequisitesIndexUrl()}/${invoiceId}`;
}


export function invoiceCompanyRequisitesUpdateUrl(invoiceId) {
  return `${baseUrl}/invoice-company-requisites/${invoiceId}`;
}


export function invoiceExportCreateUrl() {
  return `${baseUrl}/invoice-export/create`;
}

export function invoiceExportStoreUrl() {
  return `${baseUrl}/invoice-export`;
}

export function invoicePartialUpdateUrl(invoiceId) {
  return `${baseUrl}/invoice-partial/${invoiceId}`;
}

export function invoiceConvertEditUrl(invoiceId) {
  return `${baseUrl}/invoice-convert/${invoiceId}/edit/`;
}

export function invoiceConvertUpdateUrl(invoiceId) {
  return `${baseUrl}/invoice-convert/${invoiceId}`;
}

export function invoiceSaveCheckUrl() {
  return `${baseUrl}/invoice-save-check`;
}

export function invoiceImportCreateUrl() {
  return `${invoiceIndexUrl()}/import/create`;
}

export function invoiceImportStoreUrl() {
  return `${invoiceIndexUrl()}/import`;
}

export function invoicePaymentsImportUrl() {
  return `${invoiceIndexUrl()}/import/payments/create`;
}

export function invoicePaymentsImportCreateUrl() {
  return `${invoiceIndexUrl()}/import/payments/prepare`;
}

export function invoicePaymentsImportStoreUrl() {
  return `${invoiceIndexUrl()}/import/payments`;
}

// Invoice payment modal urls
export function invoicePaymentModalCreateUrl(invoiceId) {
  return `${baseUrl}/invoice-payments/${invoiceId}/create`;
}

export function invoicePaymentModalEditUrl(paymentId) {
  return `${baseUrl}/invoice-payments/${paymentId}/edit`;
}


export function invoicePaymentModalStoreUrl(invoiceId) {
  return `${baseUrl}/invoice-payments/${invoiceId}`;
}

export function invoicePaymentModalUpdateUrl(paymentId) {
  return `${baseUrl}/invoice-payments/${paymentId}/update`;
}

export function invoicePaymentDeleteUrl(invoiceId) {
  return `${baseUrl}/invoice-payments/${invoiceId}`;
}

export function invoiceRestoreUrl(invoiceId) {
  return `${baseUrl}/invoice-restore/${invoiceId}`;
}

export function invoicePaymentCheckUrl(invoiceId) {
  return `${baseUrl}/invoice-payment-check/${invoiceId}`;
}

export function invoicePaymentFileFormUrl() {
  return `${baseUrl}/invoice-payments/files`;
}

// Invoice free form doc modal urls
export function invoiceFreeFormDocModalCreateUrl(invoiceId) {
  return `${baseUrl}/invoice-free-from-doc/${invoiceId}`;
}

export function invoiceFreeFormDocModalStoreUrl(invoiceId) {
  return `${baseUrl}/invoice-free-from-doc/${invoiceId}`;
}

export function invoicePdfViewUrl(invoiceId, language) {
  return `${baseUrl}/invoices/${invoiceId}/pdf/view/${language}`;
}

// invoice pdf urls
export function invoicePdfPrintUrl(invoiceId, language) {
  return `${baseUrl}/invoices/${invoiceId}/pdf/print/${language}`;
}

export function invoiceDownloadUrl(invoiceId, language, format = 'pdf') {
  return `${baseUrl}/invoices/${invoiceId}/${format}/download/${language}`;
}

// Invoice email urls
export function invoiceEmailIndexUrl(invoiceId) {
  return `${baseUrl}/invoice-emails/${invoiceId}`;
}

export function invoiceEmailModalCreateUrl(invoiceId) {
  return `${baseUrl}/invoice-emails/${invoiceId}/create`;
}

export function invoiceEmailModalStoreUrl(invoiceId) {
  return `${baseUrl}/invoice-emails/${invoiceId}`;
}

export function createInvoiceEmailModalCreateUrl() {
  return `${baseUrl}/create-invoice-emails/create`;
}

// Invoice draft urls
export function invoiceDraftStoreUrl() {
  return `${baseUrl}/invoice-drafts`;
}

export function invoiceDraftUpdateUrl(invoiceId) {
  return `${baseUrl}/invoice-drafts/${invoiceId}`;
}

export function invoiceDraftDeleteUrl(invoiceId) {
  return `${baseUrl}/invoice-drafts/${invoiceId}`;
}

export function invoiceClientSignatureFileStoreUrl() {
  return `${baseUrl}/invoice-client-signatures/files`;
}

export function invoiceCoverStoreUrl() {
  return `${invoiceIndexUrl()}/cover`;
}

export function invoiceMassActionUrl() {
  return `${invoiceIndexUrl()}/mass-actions`;
}

export function invoiceMassActionExportUrl() {
  return `${invoiceIndexUrl()}/mass-actions/export`;
}

export function invoiceUnlinkWaybillUrl(invoiceId) {
  return `${invoiceIndexUrl()}/${invoiceId}/unlink-waybill`;
}

export function invoicePaymentValidateUrl() {
  return `${baseUrl}/invoice-payment-validation`;
}
